<ion-row class="ion-justify-content-between">
  <ion-col
    size="2"
    class="each-emoji ion-text-center ion-no-padding"
    *ngFor="let emojiItem of view().emojis"
    [class.selected]="emojiItem.isSelected"
    [class.unselected]="view().isAnyEmojiSelected && !emojiItem.isSelected"
    (click)="selectEmoji(emojiItem.emoji)"
  >
    <img [src]="'assets/common/emoji_' + emojiItem.emoji.replace('_', '-') + '.svg'" [alt]="emojiItem.emoji" />
    <ion-text color="dark" class="emoji-text">
      <p>{{ 'nps.' + emojiItem.emoji | translate }}</p>
    </ion-text>
  </ion-col>
</ion-row>

<ng-container *ngIf="view().options.length > 0">
  <ion-text color="dark" class="questions-header">
    <p class="ion-margin-start">
      {{
        (view().isDetractorSelected ? 'nps.questions_header_detractor' : 'nps.questions_header_promoter') | translate
      }}
    </p>
  </ion-text>

  <ion-list class="list-wrapper ion-no-padding ion-no-margin ion-align-items-center">
    <ion-item class="ion-no-padding ion-no-margin" *ngFor="let option of view().options" lines="none">
      <ion-checkbox
        class="ion-margin-horizontal"
        slot="start"
        [checked]="option.isSelected"
        (ionChange)="onOptionChange(option, $event)"
      >
      </ion-checkbox>

      <ion-label class="ion-text-wrap ion-no-margin" color="dark">
        {{ option.value }}
      </ion-label>
    </ion-item>
  </ion-list>
</ng-container>
